import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appTrim]',
    standalone: false
})
export class TrimDirective {

  constructor(private ngControl: NgControl) {
   
  }

  @HostListener('blur')
  onBlur() {
    const value = this.ngControl.control?.value;
    if (value && typeof value === 'string') {
      // Trim only the leading and trailing spaces
      this.ngControl.control?.setValue(value.trim());
    }
  }

}
